import forOwn from 'mout/object/forOwn'
/**
 * Finds all items that have at least one node with a name matching the filter
 * @param {object} nodes All nodes from knowledge map
 * @param {object} items Items to filter
 * @param {string} searchTerm Letters to match to node names
 * @param {object} activeItems Object that gives Id's paired with true for items that should be included no matter what 
 * @returns {object} All items that have at least one node that matches the name filter
 */
export default function filterByNodes (nodes, items, searchTerm, activeItems) {

  let matchingNodes = {}

  // Find all nodes with search term in their names
  forOwn(nodes, (val, key, o) => {
    if (val.name) {
      if (val.name.toLowerCase().search(searchTerm.toLowerCase()) !== -1) {
        matchingNodes[key] = true
      }
    }
  })

  let matchingItems = {}

  // Find all items that have at least 1 matching node
  forOwn(items, (val, key, o) => {
    if (val.nodeTags) {
      let nodeMatch = false
      forOwn(val.nodeTags, (nval, nkey, no) => {
        if (nval && matchingNodes[nkey]) {
          nodeMatch = true
        }
      })
      if (nodeMatch || activeItems[val.itemId]) {
        matchingItems[key] = val
      }
    } else if (activeItems[val.itemId]) {
      matchingItems[key] = val
    }
  })

  return matchingItems

}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/filterByNodes.js